<template>
    <div class="form__field">
        <label
            :for="compId"
            class="form__label"
        >
            {{ label }}
        </label>
        <input
            :id="compId"
            :placeholder="placeholder || label"
            :value="modelValue"
            :aria-describedby="error ? `${compId}-error` : null"
            :aria-invalid="!!error"
            v-bind="$attrs"
            @input="$emit('update:modelValue', $event.target.value)"
            :class="{'has-error': error}"
        />
        <p
            v-if="error"
            :id="`${compId}-error`"
            class="form__error"
            aria-live="assertive"
        >
            {{ error }}
        </p>
    </div>
</template>

<script setup>
import { useId } from 'vue'

const compId = 'field-' + useId()
defineProps({
    label: {
        type: String,
        default: '',
    },
    placeholder: {
        type: String,
        default: '',
    },
    modelValue: {
        type: [String, Number],
        default: '',
    },
    error: {
        type: String,
        default: ''
    }
})
</script>
